const Component2 = ({ items, handleSelection, selectedCategory, selectedColor }) => {
  const isOutOfStock = (item) => {
    const v = item?.out_of_stock;
    return v === 1 || v === true || v === "1" || v === "true";
  };

  return (
    <div className="grid-container w-100 h-100 d-flex gap-2">
      {items.map((item, index) => (
        <div
          key={`color-${index}`}
          style={{
            backgroundImage: `url("${item.bg}")`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: item?.id === "none" ? "60% auto" : "cover",
          }}
          onClick={() => {
            if (isOutOfStock(item)) return;
            handleSelection(selectedCategory, item.id);
          }}
          className={`
            grid-item w-100 h-100 d-flex flex-1 rounded-4
            ${selectedColor === item.id ? "selected-border" : ""}
            ${isOutOfStock(item) ? "disabled" : ""}
            ${item.id === "none" ? "grid-item-none" : ""}
          `.trim()}
        ></div>
      ))}
    </div>
  );
};

export default Component2;
